import {base64DecToArr, base64EncArr} from "./base64";
import {ModelIdSize, RowKeySize} from "../schema/dt-schema";

let tmpBuf_ = new Uint8Array(RowKeySize);

export function encodeFullId(modelGuid, elementId) {
	base64DecToArr(modelGuid, tmpBuf_, 0);
	base64DecToArr(elementId, tmpBuf_, ModelIdSize);

	return base64EncArr(tmpBuf_, 0, RowKeySize);
}
